import { createSelector } from "reselect";

import { getEnvdDocuments, getSpecies } from "../root";

const EnvdMappingStatus = {
  TODO: "To Do",
  VENDOR_INCOMPLETE: "Vendor Incomplete",
  DONE: "Done",
};

const getMappingStatus = envdDocument => {
  if (envdDocument.livestockSaleId || envdDocument.deploymentSaleId) {
    return EnvdMappingStatus.DONE;
  } else if (!envdDocument.isComplete) {
    return EnvdMappingStatus.VENDOR_INCOMPLETE;
  } else {
    return EnvdMappingStatus.TODO;
  }
};

export const selectEnvdDocumentsAggridData = createSelector(
  [getEnvdDocuments, getSpecies],
  (envdDocuments, species) => {
    return Object.values(envdDocuments).map(envdDocument => ({
      envdDocument,
      species: species[envdDocument.speciesId],
      mappingStatus: getMappingStatus(envdDocument),
      // These two fields are used for editing/mapping actions.
      deploymentId: envdDocument.deploymentId,
      livestockSaleId: envdDocument.livestockSaleId,
    }));
  },
);
